import { Button, CardTitle } from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from 'react-icons/fa';
import { useState } from 'react';
import { BuildingReadModel, PackageType, useGetBuildingsQuery } from '@client/api';
import { SelectionModal } from '../../../../components/selection-modal/selection-modal';

export const BuildingSelectionModal = ({
  onChange,
  selectedBuilding,
  searchQuery,
  packageFilter,
  showLabel = true,
}: {
  onChange: (building: BuildingReadModel[]) => void;
  selectedBuilding: BuildingReadModel[];
  searchQuery?: (params: { search: string; 'pagination.Limit': number; 'pagination.Offset': number }) => any;
  packageFilter?: PackageType;
  showLabel?: boolean;
}) => {
  const { t } = useTranslation('dashboard');
  const { t: tCommon } = useTranslation('common');
  const { t: tGlobal } = useTranslation('global');
  const [openBuildingModal, setOpenBuildingModal] = useState(false);

  // Create a query function that includes the package filter
  const buildingsQuery = (params: { search: string; 'pagination.Limit': number; 'pagination.Offset': number }) => {
    return useGetBuildingsQuery({
      ...params,
      'requiredPackage.Equal': packageFilter,
    });
  };

  return (
    <div className="flex flex-col gap-2">
      {showLabel && (
        <CardTitle className="flex-1" variant="dense">
          {t('buildingTitle')}
        </CardTitle>
      )}
      <Button
        color="primary-invert"
        size="sm"
        className="w-full justify-between text-white h-[40px]"
        onClick={() => setOpenBuildingModal(true)}
        endIcon={<FaChevronDown />}
      >
        {selectedBuilding.length > 0 ? t('selectedBuildings') : t('building')}
      </Button>
      <SelectionModal
        open={openBuildingModal}
        selected={selectedBuilding}
        onClose={() => setOpenBuildingModal(false)}
        onSubmit={(value: BuildingReadModel[]) => {
          setOpenBuildingModal(false);
          onChange(value);
        }}
        title={tCommon('selectEntity', { entity: tGlobal('entity.building', { context: 'plural' }).toLowerCase() })}
        searchQuery={packageFilter ? buildingsQuery : searchQuery || useGetBuildingsQuery}
        getItemName={(building) => building.name ?? ''}
        entityName="entity.building"
      />
    </div>
  );
};
